setTimeout(function () {
  var $ = jQuery;
  positionHeader();

  // $(window).on("resize", function () {
  //   positionHeader();
  // });

  function positionHeader() {
    // var timerInt = setInterval(timerLoaded, 100);
    // timerI = 0;
    // function timerLoaded() {
    //   if ($("#timerBar").length) {
    //     setTimeout(function () {
    //       clearInterval(timerInt);

    //       var timerHeight = $("#timerBar").height();

    //       console.log($("#timerBar .timer-bar"));
    //       var headerHeight = $(".siteheader").height();
    //       var topOffset = 0;

    //       if ($(window).width() < 768) {
    //         topOffset = 10;
    //         if ($("body").hasClass("template-product")) {
    //           topOffset = -10;
    //         }
    //       }
    //       if ($(".siteheader").hasClass("home")) {
    //         topOffset = 0;
    //       }

    //       $(".siteheader").css("top", timerHeight + "px");
    //       $(".page-container").css(
    //         "padding-top",
    //         timerHeight + headerHeight + topOffset + "px"
    //       );
    //     }, 1000);
    //   }
    //   if (timerI++ == 100) {
    //     clearInterval(timerInt);
    //   }
    // }
    if ($("#timerBar").length) {
      setTimeout(function () {
        // clearInterval(timerInt);

        var timerHeight = $("#timerBar .timer-bar").height();

        console.log(timerHeight);
        console.log(headerHeight);

        var headerHeight = $(".siteheader").height();
        var topOffset = 0;

        // if ($(window).width() < 768) {
        //   topOffset = 10;
        //   if ($("body").hasClass("template-product")) {
        //     topOffset = -10;
        //   }
        // }
        // if ($(".siteheader").hasClass("home")) {
        //   topOffset = 0;
        // }

        $(".siteheader").css("top", timerHeight + "px");
        $(".page-container").css(
          "padding-top",
          timerHeight + headerHeight + topOffset + "px"
        );
      }, 1000);
    }
  }

  $(".show-menu, .hide-menu").on("click", function () {
    $(".sitenav").toggleClass("show-mobile-menu");
    $(".siteheader").toggleClass("dropdown-visible");
  });

  $(".hide-menu").on("click", function () {
    $(".siteheader .sitenav .item.show-dropdown").each(function () {
      $(this).removeClass("show-dropdown");
    });
  });

  $(".siteheader .sitenav .item.has-dropdown").on("click", function () {
    $(this).toggleClass("show-dropdown");
  });

  console.log(
    $("li.speero-has-dropdown.show-dropdown div.ul-wrapper .ctmNav li")
  );

  $("li.speero-has-dropdown.show-dropdown div.ul-wrapper .ctmNav li").on(
    "click",
    function () {
      console.log("oiiii");
    }
  );

  $("#notify-me").click(function () {
    $("#notify-me-wrapper").fadeIn();
    return false;
  });

  //     var pageWidth = $(window).width();
  //     if (pageWidth <= 640) {
  //         $('.press-section').find('.desktop').css('display', 'none');
  //         $('.press-section').find('.mobile').css('display', 'block');
  //     }

  //     $(window).resize(function () {
  //         var pageWidth = $(window).width();
  //         if (pageWidth <= 640) {
  //             $('.press-section').find('.desktop').css('display', 'none');
  //             $('.press-section').find('.mobile').css('display', 'block');
  //         }
  //         if (pageWidth >= 640) {
  //             $('.press-section').find('.desktop').css('display', 'block');
  //             $('.press-section').find('.mobile').css('display', 'none');
  //         }
  //     });

  //     $(window).scroll(function (event) {
  //         var scroll = $(window).scrollTop();
  //         if ($(window).scrollTop() + $(window).height() > $(document).height() - 550) {
  //             $('.press-section').find('.desktop').css('margin-top', 0).css('opacity', '1');
  //             $('.press-section').find('.mobile').css('margin-top', 0).css('opacity', '1');
  //         }
  //     });

  jQuery("#hero-slider").slick({
    dots: true,
    accessibility: false,
    infinite: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });

  var variantId = $("#product-image-slider").data("variant-first");
  var slickInitialSlide = $('[data-variant-id="' + variantId + '"]')
    .closest(".product-single__photo-wrapper")
    .index();

  $("#product-image-slider").on("init", function (slick) {
    $("#product-image-slider").removeClass("hidden");
  });

  $("#product-image-slider").slick({
    dots: true,
    accessibility: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    prevArrow:
      '<button type="button" class="slick-prev"><img src="//cdn.shopify.com/s/files/1/1002/1104/t/154/assets/home_slide_prev.png?v=14016273412778762052" alt=""></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="//cdn.shopify.com/s/files/1/1002/1104/t/154/assets/home_slide_next.png?v=2346459143004065662" alt=""></button>',
    appendDots: "#product-image-sdots",
    initialSlide: slickInitialSlide > 0 ? slickInitialSlide : 0,
  });

  // $("#mglasser").on("click", function () {
  //   $(".product-single__photo")
  //     .magnificPopup({
  //       type: "image",
  //       mainClass: "mfp-with-zoom",
  //       modal: true,
  //       closeBtnInside: false,
  //       showCloseBtn: true,
  //       closeOnContentClick: false,
  //       callbacks: {
  //         beforeOpen: function () {
  //           appendHtmlForMfpSlider();
  //         },
  //         resize: function () {
  //           setSliderEquialheight();
  //         },
  //         open: function () {
  //           // Will fire when this exact popup is opened
  //           // this - is Magnific Popup object
  //         },
  //         imageLoadComplete: function () {
  //           // fires when image in current popup finished loading
  //           // avaiable since v0.9.0
  //           $(".mfp-content").append(htmlToInsert);

  //           setTimeout(function () {
  //             initMfpSliderInside();
  //             setSliderEquialheight();
  //             initPanZoom();
  //           }, 150);
  //           $("#mfp-close").on("click", function () {
  //             $.magnificPopup.close();
  //           });
  //         },
  //       },
  //     })
  //     .magnificPopup("open");
  // });

  var htmlToInsert = "";

  function setSliderEquialheight() {
    var winH = $(window).height();
    var sliderH = $("#mfp-inner-slider").height();

    if (winH < sliderH) {
      $("#mfp-inner-slider").height($(window).height());
    } else {
      $("#mfp-inner-slider").height("auto");
    }
  }

  function initPanZoom() {
    var $mfp = $(".mfp-content");
    $(".mfp-islide").panzoom({
      $zoomIn: $mfp.find(".zoom-in"),
      $zoomOut: $mfp.find(".zoom-out"),
      panOnlyWhenZoomed: true,
    });
  }

  function initMfpSliderInside() {
    $("#mfp-inner-slider").on("init", function (slick) {
      if ($(window).width() >= 1280) {
        $(".mfp-islide.slick-current").on("dblclick", function () {
          $(".mfp-islide").panzoom("zoom");
        });
      }
    });

    $("#mfp-inner-slider").on("afterChange", function (slick) {
      if ($(window).width() >= 1280) {
        $(".mfp-islide.slick-current").on("dblclick", function () {
          $(".mfp-islide").panzoom("zoom");
        });
      }
    });

    $("#mfp-inner-slider").slick({
      dots: true,
      accessibility: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear",
      prevArrow:
        '<button type="button" class="slick-prev"><img src="//cdn.shopify.com/s/files/1/1002/1104/t/154/assets/home_slide_prev.png?v=14016273412778762052" alt=""></button>',
      nextArrow:
        '<button type="button" class="slick-next"><img src="//cdn.shopify.com/s/files/1/1002/1104/t/154/assets/home_slide_next.png?v=2346459143004065662" alt=""></button>',
    });
  }

  function appendHtmlForMfpSlider() {
    var $slides = $(".product-single__photo");
    var $slideWraps = $(".product-single__photo-wrapper");
    htmlToInsert = '<div id="mfp-inner-slider" class="mfp-inner-slider">';

    var activeSliderList = [];
    var nonActiveSliderList = [];
    var sortedSliderList = [];

    $slideWraps.each(function (index, item) {
      var $slide = $(item);
      if ($slide.hasClass("slick-active")) {
        activeSliderList.push(item);
      } else {
        nonActiveSliderList.push(item);
      }
    });

    sortedSliderList = activeSliderList.concat(nonActiveSliderList);
    sortedSliderList.forEach(function (slide, index) {
      var $slide = $(slide);
      var src = $slide.find("img").attr("data-mfp-src");
      htmlToInsert +=
        '<div class="mfp-islide"><img src="' + src + '" alt=""></div>';
    });

    htmlToInsert += '</div><div id="mfp-close" class="mfp-close">×</div>';
    htmlToInsert += '<div class="zbuttons">';
    htmlToInsert += '<button class="zoom-in"></button>';
    htmlToInsert += '<button class="zoom-out"></button>';
    htmlToInsert += "</div>";
  }

  // if ($(window).width() >= 1280) {
  //   $(".product-single__photo").magnificPopup({
  //     type: "image",
  //     mainClass: "mfp-with-zoom",
  //     modal: true,
  //     closeBtnInside: false,
  //     showCloseBtn: true,
  //     closeOnContentClick: false,
  //     callbacks: {
  //       beforeOpen: function () {
  //         appendHtmlForMfpSlider();
  //       },
  //       resize: function () {
  //         setSliderEquialheight();
  //       },
  //       open: function () {
  //         // Will fire when this exact popup is opened
  //         // this - is Magnific Popup object
  //       },
  //       imageLoadComplete: function () {
  //         // fires when image in current popup finished loading
  //         // avaiable since v0.9.0
  //         $(".mfp-content").append(htmlToInsert);

  //         setTimeout(function () {
  //           initMfpSliderInside();
  //           setSliderEquialheight();
  //           initPanZoom();
  //         }, 200);

  //         $("#mfp-close").on("click", function () {
  //           $.magnificPopup.close();
  //         });
  //       },
  //     },
  //   });
  // }

  function connectSwatchesIdVsSlider(id) {
    var swatchesId = id;
    var $productSlider = $("#product-image-slider");
    var slickIndex = $('[data-variant-id="' + swatchesId + '"]')
      .closest(".slick-slide")
      .index();

    if ($productSlider.length && typeof swatchesId !== "undefined") {
      $productSlider.slick("slickGoTo", slickIndex);
    }
  }

  $(window).on("swatchesChanged", function (event, data) {
    var swatchesId = data.id;
    connectSwatchesIdVsSlider(swatchesId);
  });

  $(".secret-button a").on("click", function () {
    var int = setInterval(loaded, 100);
    var i = 0;
    function loaded() {
      if (
        $(".fancybox-container .fancybox-inner").length &&
        $(".sellify-countdown-timer-holder").length
      ) {
        clearInterval(int);
        $(".fancybox-container .fancybox-inner").css(
          "top",
          $(".sellify-countdown-timer-holder").height()
        );
      }
      if (i++ == 100) {
        clearInterval(int);
      }
    }
  });
});
